import { TransportCatalogSearchCriteria } from '../../models';

export class LoadCatalogFetch {
  public static readonly type = '[LoadCatalog] Fetch';
  constructor(public payload: Partial<TransportCatalogSearchCriteria>) {}
}

export class LoadCatalogInitialState {
  public static readonly type = '[LoadCatalog] Set Initial State';
}
